import * as React from "react";
import { markdown, ReactSpecimen } from "catalog";
import { H1, H2, H3, H4, Paragraph, Small, Strong, Em, InlineLinkAnchor, DefinitionList, OrderedList, UnorderedList, Table } from "./text";
const wideHeaders = [
    "TAG",
    "MONAT",
    "JAHR",
    "RAUM",
    "KENNZAHL",
    "GRUPPE1",
    "GRUPPENCODE1",
    "GRUPPE2",
    "GRUPPENCODE2",
    "GRUPPE3",
    "GRUPPENCODE3",
    "GRUPPE4",
    "GRUPPENCODE4",
    "GRUPPE5",
    "GRUPPENCODE5",
    "CODE",
    "WERT",
    "Codename",
    "Kennzahlname",
    "Einheit"
];
const wideRows = [
    [
        "1",
        "12",
        "1888",
        "R10000",
        "BEW",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "BEWXXX0000XXX0000XXX0000XXX0000XXX0000",
        "27644",
        "Wirtschafliche Bevölkerung",
        "Bevölkerung",
        "Personen"
    ],
    [
        "10",
        "12",
        "1860",
        "R10000",
        "BEW",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "BEWXXX0000XXX0000XXX0000XXX0000XXX0000",
        "19758",
        "Wirtschafliche Bevölkerung",
        "Bevölkerung",
        "Personen"
    ],
    [
        "17",
        "3",
        "1850",
        "R10000",
        "BEW",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "BEWXXX0000XXX0000XXX0000XXX0000XXX0000",
        "17040",
        "Wirtschafliche Bevölkerung",
        "Bevölkerung",
        "Personen"
    ],
    [
        "31",
        "12",
        "1408",
        "R10000",
        "BEW",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "BEWXXX0000XXX0000XXX0000XXX0000XXX0000",
        "5675",
        "Wirtschafliche Bevölkerung",
        "Bevölkerung",
        "Personen"
    ],
    [
        "31",
        "12",
        "1467",
        "R10000",
        "BEW",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "BEWXXX0000XXX0000XXX0000XXX0000XXX0000",
        "4750",
        "Wirtschafliche Bevölkerung",
        "Bevölkerung",
        "Personen"
    ],
    [
        "31",
        "12",
        "1529",
        "R10000",
        "BEW",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "BEWXXX0000XXX0000XXX0000XXX0000XXX0000",
        "5080",
        "Wirtschafliche Bevölkerung",
        "Bevölkerung",
        "Personen"
    ],
    [
        "31",
        "12",
        "1637",
        "R10000",
        "BEW",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "BEWXXX0000XXX0000XXX0000XXX0000XXX0000",
        "8621",
        "Wirtschafliche Bevölkerung",
        "Bevölkerung",
        "Personen"
    ],
    [
        "31",
        "12",
        "1671",
        "R10000",
        "BEW",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "BEWXXX0000XXX0000XXX0000XXX0000XXX0000",
        "9590",
        "Wirtschafliche Bevölkerung",
        "Bevölkerung",
        "Personen"
    ],
    [
        "31",
        "12",
        "1682",
        "R10000",
        "BEW",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "BEWXXX0000XXX0000XXX0000XXX0000XXX0000",
        "11110",
        "Wirtschafliche Bevölkerung",
        "Bevölkerung",
        "Personen"
    ],
    [
        "31",
        "12",
        "1762",
        "R10000",
        "BEW",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "BEWXXX0000XXX0000XXX0000XXX0000XXX0000",
        "11452",
        "Wirtschafliche Bevölkerung",
        "Bevölkerung",
        "Personen"
    ],
    [
        "31",
        "12",
        "1771",
        "R10000",
        "BEW",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "BEWXXX0000XXX0000XXX0000XXX0000XXX0000",
        "10574",
        "Wirtschafliche Bevölkerung",
        "Bevölkerung",
        "Personen"
    ],
    [
        "31",
        "12",
        "1792",
        "R10000",
        "BEW",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "BEWXXX0000XXX0000XXX0000XXX0000XXX0000",
        "10734",
        "Wirtschafliche Bevölkerung",
        "Bevölkerung",
        "Personen"
    ],
    [
        "31",
        "12",
        "1799",
        "R10000",
        "BEW",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "BEWXXX0000XXX0000XXX0000XXX0000XXX0000",
        "10000",
        "Wirtschafliche Bevölkerung",
        "Bevölkerung",
        "Personen"
    ],
    [
        "31",
        "12",
        "1812",
        "R10000",
        "BEW",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "BEWXXX0000XXX0000XXX0000XXX0000XXX0000",
        "9715",
        "Wirtschafliche Bevölkerung",
        "Bevölkerung",
        "Personen"
    ],
    [
        "31",
        "12",
        "1833",
        "R10000",
        "BEW",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "BEWXXX0000XXX0000XXX0000XXX0000XXX0000",
        "10936",
        "Wirtschafliche Bevölkerung",
        "Bevölkerung",
        "Personen"
    ],
    [
        "31",
        "12",
        "1836",
        "R10000",
        "BEW",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "BEWXXX0000XXX0000XXX0000XXX0000XXX0000",
        "14243",
        "Wirtschafliche Bevölkerung",
        "Bevölkerung",
        "Personen"
    ],
    [
        "31",
        "12",
        "1870",
        "R10000",
        "BEW",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "BEWXXX0000XXX0000XXX0000XXX0000XXX0000",
        "20760",
        "Wirtschafliche Bevölkerung",
        "Bevölkerung",
        "Personen"
    ],
    [
        "31",
        "12",
        "1880",
        "R10000",
        "BEW",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "XXX",
        "XXX0000",
        "BEWXXX0000XXX0000XXX0000XXX0000XXX0000",
        "25102",
        "Wirtschafliche Bevölkerung",
        "Bevölkerung",
        "Personen"
    ]
];
export default () => markdown `

## Headings
### H1
${(<ReactSpecimen>
    <H1>Statistisches Informationsportal</H1>
  </ReactSpecimen>)}
### H2
${(<ReactSpecimen>
    <H2>Statistisches Informationsportal</H2>
  </ReactSpecimen>)}
### H3
${(<ReactSpecimen>
    <H3>Statistisches Informationsportal</H3>
  </ReactSpecimen>)}
### H4
${(<ReactSpecimen>
    <H4>
      Escher Wyss: Von der Industriebrache zum Trendquartier -
      Präsentationsfolien Statistik um 12
    </H4>
  </ReactSpecimen>)}

## Paragraph Styles
### Paragraph
${(<ReactSpecimen>
    <Paragraph>
      Im Rahmen des Öffentlichkeitsprinzips macht die Stadt Zürich wichtige
      Informationen auf dem Internet allgemein verfügbar. Die Stadt Zürich kann
      nicht verhindern, dass sich die typischen Risiken der von ihr auf dem
      Internet zur Verfügung gestellten Informationen in einzelnen Fällen
      verwirklichen. Städtische Internetseiten können deshalb nur unter
      folgenden Voraussetzungen und Einschränkungen genutzt werden.
    </Paragraph>
  </ReactSpecimen>)}

### Small Paragraph
${(<ReactSpecimen>
    <Small>
      Im Rahmen des Öffentlichkeitsprinzips macht die Stadt Zürich wichtige
      Informationen auf dem Internet allgemein verfügbar. Die Stadt Zürich kann
      nicht verhindern, dass sich die typischen Risiken der von ihr auf dem
      Internet zur Verfügung gestellten Informationen in einzelnen Fällen
      verwirklichen. Städtische Internetseiten können deshalb nur unter
      folgenden Voraussetzungen und Einschränkungen genutzt werden.
    </Small>
  </ReactSpecimen>)}

## Inline Styles
### Strong
${(<ReactSpecimen>
    <Paragraph>
      Als <Strong>Bevölkerungsbestand</Strong> wird in dieser Publikation die
      historische Bestandesgrösse der Bevölkerung bezeichnet.
    </Paragraph>
  </ReactSpecimen>)}

### Em
${(<ReactSpecimen>
    <Paragraph>
      Als <Em>Bevölkerungsbestand</Em> wird in dieser Publikation die
      historische Bestandesgrösse der Bevölkerung bezeichnet.
    </Paragraph>
  </ReactSpecimen>)}

### InlineLinkAnchor
${(<ReactSpecimen>
    <Paragraph>
      Als Bevölkerungsbestand wird in dieser{" "}
      <InlineLinkAnchor>Publikation</InlineLinkAnchor> die historische
      Bestandesgrösse der Bevölkerung bezeichnet. Der Bevölkerungsbestand wird
      für die Parameterschätzungen verwendet, welche auf historischen Daten
      basieren.
    </Paragraph>
  </ReactSpecimen>)}

## List Styles
### DefinitionList
${(<ReactSpecimen>
    <DefinitionList listItems={[
    "1 = zur Bereichsauswahl (horizontale Navigation)",
    "2 = zum Inhalt",
    "5 = zur Suche",
    "6 = zur Hilfsnavigation (z. B. Kontakte, Jobs)",
    "7 = zu den weiteren Informationen",
    "8 = zur Sprachauswahl",
    "L = Seite vorlesen"
]}/>
  </ReactSpecimen>)}

### OrderedList
${(<ReactSpecimen>
    <OrderedList listItems={[
    "zur Bereichsauswahl (horizontale Navigation)",
    "zum Inhalt",
    "zur Suche",
    "zur Hilfsnavigation (z. B. Kontakte, Jobs)",
    "zu den weiteren Informationen",
    "zur Sprachauswahl",
    "Seite vorlesen"
]}/>
  </ReactSpecimen>)}

### UnorderedList
${(<ReactSpecimen>
    <UnorderedList listItems={[
    "zur Bereichsauswahl (horizontale Navigation)",
    "zum Inhalt",
    "zur Suche",
    "zur Hilfsnavigation (z. B. Kontakte, Jobs)",
    "zu den weiteren Informationen",
    "zur Sprachauswahl",
    "Seite vorlesen"
]}/>
  </ReactSpecimen>)}

## Table
${(<ReactSpecimen>
    <Table headers={["Datum", "Beschrieb"]} rows={[
    ["17. April 2017", "Jährliche Aktualisierung"],
    ["15. April 2017", "Korrektur Personen/2018"],
    ["13. April 2016", "Jährliche Aktualisierung"],
    ["16. May 2017", "Korrektur Personen/2018"],
    ["23. April 2017", "Jährliche Aktualisierung"]
]}/>
  </ReactSpecimen>)}

## Wide Table
${(<ReactSpecimen>
    <Table headers={wideHeaders} rows={wideRows}/>
  </ReactSpecimen>)}
`;



// WEBPACK FOOTER //
// ./src/theme/text.docs.tsx